import React from "react";
import {ButtonInProjectCard} from "./ButtonStyles";
import styled from "styled-components";

const GoToGuidedUpdateProjectButton = ({ goToGuidedUpdate }) => {
    return(
        <Btn onClick={goToGuidedUpdate}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="#3394F6"/>
                <path
                    d="M10.9972 9.02847V12.2485C10.9972 12.5547 11.1635 12.8435 11.426 13.001L14.156 14.6197C14.471 14.8035 14.8735 14.6985 15.0572 14.3922C15.241 14.0772 15.1447 13.6747 14.8297 13.491L12.3185 11.9947V9.01972C12.3097 8.66972 12.0122 8.37222 11.6535 8.37222C11.2947 8.37222 10.9972 8.66972 10.9972 9.02847ZM19.7472 9.68472V5.05597C19.7472 4.66222 19.2747 4.46972 19.0035 4.74972L17.446 6.30722C15.8622 4.72347 13.6047 3.81347 11.1372 4.03222C7.47098 4.36472 4.45223 7.31347 4.04973 10.9797C3.52473 15.7222 7.22598 19.7472 11.8722 19.7472C15.8885 19.7472 19.2047 16.7372 19.686 12.8522C19.7472 12.3272 19.336 11.8722 18.811 11.8722C18.3735 11.8722 18.006 12.196 17.9535 12.6247C17.5772 15.6785 14.9435 18.041 11.7847 17.9972C8.53848 17.9535 5.79973 15.2147 5.74723 11.9597C5.69473 8.54722 8.46848 5.74722 11.8722 5.74722C13.561 5.74722 15.0922 6.43847 16.2035 7.54097L14.3747 9.36972C14.0947 9.64972 14.2872 10.1222 14.681 10.1222H19.3097C19.5547 10.1222 19.7472 9.92972 19.7472 9.68472Z"
                    fill="#FAFAFA"/>
            </svg>
            <p> Mettre à jour le pitch projet </p>
        </Btn>
    )
}
const Btn = styled(ButtonInProjectCard)`
`

export default GoToGuidedUpdateProjectButton;